import React from 'react';
import '../styles/ProductShowcase.css';

const ProductShowcase = () => {
  return (
    <section className="product-showcase">
      <div className="content-container">
        <div className="text-content">
          <h1 className="heading">
            <span className="blue-text">UNE GAMME</span><br />
            <span className="yellow-text">COMPLÈTE</span> 
            <span className="blue-text">DE</span><br />
            <span className="blue-text">MATÉRIELS BTP</span>
          </h1>
          
          <div className="description">
            <p>
              En tant que Distributeur exclusif de LiuGong au Maroc, LGM met à 
              votre disposition une gamme complète.
            </p>
            <p>
              Depuis plus de 65 ans, LiuGong conçoit des machines robustes, 
              fiables et faciles à entretenir, pensées pour durer dans les conditions 
              les plus exigeantes.
            </p>
            <p>
              Avec une présence dans plus de 170 pays LiuGong est aujourd'hui une 
              référence mondiale du matériel BTP.
            </p>
          </div>
        </div>
        
        <div className="image-container">
          <img 
            src="/assets/images/product Show Case.png" 
            alt="LiuGong Excavator on Construction Site" 
            className="excavator-image" 
          />
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;